<div class="col-md-12 plan-details">
  <div class="acc-summary" *ngIf="eprismContract && isSpoeEnabled">
    <adp-label labelKey="Account_Nav_Summary_Text"></adp-label>
    <div>&nbsp;</div>
  </div>
  <mat-card class="mat-elevation-z0 mb-5" *ngIf="!selectedContract?.isEprismContract">
    <div class="plan-card">
      <div class="container header-container">
        <div class="header-title-container">
          <p id="plan-card-title" class="plan-details__title">
            <adp-label labelKey="Account_Details_Title"></adp-label>
          </p>
        </div>

        <div ifSettingTrue="Account_Subscription_Enabled" class="manage-link desktop-view">
          <a
            href="{{ resourceService.getPortalSetting('URL_Account_Subscription_Mangement')?.Value }}"
            target="_blank"
            [gtmClick]="getViewLabel('Account_Subscription_Manage_Link_Text')"
            [gtmLinkURL]="resourceService.getPortalSetting('URL_Account_Subscription_Mangement')?.Value">
            <adp-label labelKey="Account_Subscription_Manage_Link_Text"></adp-label>
            <mat-icon [svgIcon]="'new-page'" class="open-icon"></mat-icon>
          </a>
        </div>

        <div ifSettingTrue="Account_Subscription_Enabled" class="mt-10 manage-link-mobile mobile-view">
          <a
            href="{{ resourceService.getPortalSetting('URL_Account_Subscription_Mangement')?.Value }}"
            target="_blank"
            [gtmClick]="getViewLabel('Account_Subscription_Manage_Link_Text')"
            [gtmLinkURL]="resourceService.getPortalSetting('URL_Account_Subscription_Mangement')?.Value">
            <div>
              <adp-label labelKey="Account_Subscription_Manage_Link_Text" style="float: left; margin-top: 5px"></adp-label>
              <mat-icon [svgIcon]="'new-page'" class="open-icon" style="float: right"></mat-icon>
            </div>
          </a>
        </div>
      </div>
      <div class="plan-details-info row no-gutters" aria-labelledby="plan-card-title" *ngIf="!isLoading; else loader">
        <div *ngIf="!isClientSoldType" class="col-6 plan-details__label">
          <adp-label labelKey="Account_Details_Contract_Label"></adp-label>
        </div>
        <div *ngIf="!isClientSoldType" class="col-6 plan-details__value cls_mask">{{ selectedContract?.id }}</div>
        <div class="col-6 plan-details__label">
          <adp-label labelKey="Account_Details_CustomerName_Label"></adp-label>
        </div>
        <div class="col-6 plan-details__value">{{ selectedContract?.firstName }} {{ selectedContract?.lastName }}</div>
        <div class="col-6 plan-details__label">
          <adp-label labelKey="Account_Details_Address_Label"></adp-label>
        </div>
        <div class="col-6 plan-details__value">
          <div>{{ displayStreetAddress1 }}</div>
          <div>{{ displayCityStateZip }}</div>
        </div>
        <div class="col-6 plan-details__label">
          <adp-label labelKey="Account_Details_CustomerEmail_Label"></adp-label>
        </div>
        <div class="col-6 plan-details__value">{{ selectedContract?.primaryUserEmail }}</div>

        <ng-container *ngIf="isBillingAndPaymentEnabled">
          <ng-container *ngIf="paymentInfoData?.TotalContractPriceWithTax">
            <div class="col-6 plan-details__label cls_mask">
              <adp-label labelKey="Account_Details_PaymentOption_Text"></adp-label>
            </div>
            <div class="col-6 plan-details__value">
              <ng-container *ngIf="paymentInfoData?.IsContractPaidFull">
                <adp-label labelKey="Account_Details_PaidInFull_Text"></adp-label>
              </ng-container>
              <ng-container
                *ngIf="
                  !paymentInfoData?.IsContractPaidFull &&
                  (paymentInfoData?.PaymentPlanCode === 'EVERGREEN' || paymentInfoData?.PaymentPlanCode === -1)
                ">
                <adp-label labelKey="Account_Details_MonthlyPlan_Text"></adp-label>
              </ng-container>
            </div>
          </ng-container>

          <ng-container *ngIf="paymentInfoData?.TotalContractPriceWithTax">
            <div class="col-6 plan-details__label">
              <adp-label labelKey="Account_Details_MonthlyAmount_Label"></adp-label>
            </div>
            <div class="col-6 plan-details__value cls_mask">{{ paymentInfoData?.TotalContractPriceWithTax | currency }}</div>
          </ng-container>

          <ng-container *ngIf="paymentInfoData?.PaidThroughDate">
            <div class="col-6 plan-details__label">
              <adp-label labelKey="Account_Details_PaidThrough_Label"></adp-label>
            </div>
            <div class="col-6 plan-details__value cls_mask">
              {{ paymentInfoData?.PaidThroughDate | date: 'MM/dd/yyyy' : 'UTC' + offset }}
            </div>
          </ng-container>

          <ng-container *ngIf="paymentInfoData?.ContractStartDate">
            <div class="col-6 plan-details__label">
              <adp-label labelKey="Account_Details_PlanStartDate_Label"></adp-label>
            </div>
            <div class="col-6 plan-details__value cls_mask">
              {{ paymentInfoData?.ContractStartDate | date: 'MM/dd/yyyy' : 'UTC' + offset }}
            </div>
          </ng-container>

          <ng-container *ngIf="paymentInfoData?.NextBillingDate">
            <div class="col-6 plan-details__label">
              <adp-label labelKey="Account_Details_NextBillingDate_Label"></adp-label>
            </div>
            <div class="col-6 plan-details__value cls_mask">
              {{ paymentInfoData?.NextBillingDate | date: 'MM/dd/yyyy' : 'UTC' + offset }}
            </div>
          </ng-container>
        </ng-container>

        <div *ngIf="!isSpoeEnabled || isNative"><hr class="mt-4 mb-4" /></div>
        <div class="link-container" *ngIf="isViewContractDetailsEnabled && (!isSpoeEnabled || isNative)">
          <div class="icon-container">
            <mat-icon [svgIcon]="contractDownloadLink ? contractDownloadLink?.svgIcon : 'streamline-icon-office-file-adobe'"></mat-icon>
          </div>
          <mat-spinner *ngIf="isContractMissing" class="contract-loading" [diameter]="20"></mat-spinner>
          <div class="view-contract-link-container">
            <button
              class="link"
              [class.contract-missing]="isContractMissing"
              (click)="loadPdf()"
              [disabled]="isContractMissing"
              [class.disable]="isContractMissing"
              [gtmClick]="getViewLabel('Account_Details_ViewContract_Text')"
              [gtmLinkURL]="fileURL">
              <adp-label labelKey="Account_Details_ViewContract_Text"></adp-label>
            </button>
          </div>
        </div>
      </div>
    </div>
  </mat-card>
  <mat-card class="mat-elevation-z0" *ngIf="eprismContract && isSpoeEnabled">
    <div class="plan-card">
      <div class="container header-container">
        <div class="header-title-container">
          <p id="plan-card-title" class="plan-details__title">
            <adp-label labelKey="Account_Details_Title_Secondary_Label"></adp-label>
          </p>
        </div>
      </div>
      <div class="plan-details-info row no-gutters" aria-labelledby="plan-card-title">
        <div class="col-6 plan-details__label">
          <adp-label labelKey="Account_Details_BAN_Label"></adp-label>
        </div>
        <div class="col-6 plan-details__value cls_mask">{{ eprismContract.policyIdentifier?.accountNumber }}</div>
        <div class="col-6 plan-details__label">
          <adp-label labelKey="Account_Details_Primary_Mobile_Number_Label"></adp-label>
        </div>
        <div class="col-6 plan-details__value">{{ eprismPrimaryPhone }}</div>
        <div *ngIf="eprismAuthorizedPhones?.length" class="col-6 plan-details__label">
          <adp-label labelKey="Account_Details_Mobile_Number_Label"></adp-label>
        </div>
        <div *ngIf="eprismAuthorizedPhones?.length" class="col-6 plan-details__value">{{ eprismAuthorizedPhones }}</div>
      </div>
    </div>
  </mat-card>
</div>

<ng-template #loader>
  <div class="loader">
    <mat-spinner [diameter]="50" sf-aria-label="Global_Loading_Aria_Label"></mat-spinner>
  </div>
</ng-template>
